import type {ReactElement} from 'react';
import React from 'react';
import {RecorderMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import {RecordVideoButton} from '@Panels/record-image-and-video-panel/components/record-video-button';
import {CaptureImageButton} from '@Panels/record-image-and-video-panel/components/capture-image-button';
import {useAppSelector} from '@/hooks';

interface ShutterControlButtonProps {
  captureImage(): void;
  startRecordingVideo(): void;
  isOnMobile?: boolean;
}

export function ShutterControlButton({isOnMobile = false, ...props}: ShutterControlButtonProps): ReactElement | null {
  const mediaType = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.mediaType;
  });

  const getImageAndVideoRecorderShutterButton = (): ReactElement | null => {
    if (mediaType === RecorderMediaType.VIDEO) {
      return (
        <RecordVideoButton
          isOnMobile={isOnMobile}
          onClick={() => {
            props.startRecordingVideo();
          }}
        />
      );
    }
    if (mediaType === RecorderMediaType.IMAGE) {
      return (
        <CaptureImageButton
          isOnMobile={isOnMobile}
          onClick={() => {
            props.captureImage();
          }}
        />
      );
    }
    return null;
  };

  return getImageAndVideoRecorderShutterButton();
}
